//
//
//
//
//
//
//
//
//
//
//

const TIERS = { 1: 'gold', 2: 'silver', 3: 'bronze' }

export default {
  name: 'PromotionTournamentPodiumRow',
  props: {
    position: { type: Number, required: true }, // 1, 2 or 3
    name: { type: String, required: true },
    points: { type: String, required: true },
    prize: { type: String, default: '' },
    // Overrides gold/silver/bronze with the current-user green treatment, regardless of
    // which medal position this row would otherwise get.
    isCurrentUser: { type: Boolean, default: false }
  },
  computed: {
    tier() {
      if (this.isCurrentUser) return 'current'
      return TIERS[this.position] || 'gold'
    }
  }
}
